/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Integration reconfiguration request
 * @export
 * @interface IntegrationReconfigurationRequest
 */
export interface IntegrationReconfigurationRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationReconfigurationRequest
     */
    _configuration?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationReconfigurationRequest
     */
    validateConfiguration?: boolean;
}

/**
 * Check if a given object implements the IntegrationReconfigurationRequest interface.
 */
export function instanceOfIntegrationReconfigurationRequest(value: object): value is IntegrationReconfigurationRequest {
    return true;
}

export function IntegrationReconfigurationRequestFromJSON(json: any): IntegrationReconfigurationRequest {
    return IntegrationReconfigurationRequestFromJSONTyped(json, false);
}

export function IntegrationReconfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationReconfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '_configuration': json['configuration'] == null ? undefined : json['configuration'],
        'validateConfiguration': json['validateConfiguration'] == null ? undefined : json['validateConfiguration'],
    };
}

export function IntegrationReconfigurationRequestToJSON(json: any): IntegrationReconfigurationRequest {
    return IntegrationReconfigurationRequestToJSONTyped(json, false);
}

export function IntegrationReconfigurationRequestToJSONTyped(value?: IntegrationReconfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configuration': value['_configuration'],
        'validateConfiguration': value['validateConfiguration'],
    };
}

